import React from 'react'

import Box from './Box'
import Heading from './Heading'
import Icon from './Icon'
import Text from './Text'

export default function USP({
  icon,
  iconColor = 'common.white',
  title,
  desc,
  bgColor,
}) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      bgcolor={bgColor}
      padding="50px 10px 25px 10px"
      height="100%"
      textAlign="center"
    >
      {icon && <Icon name={icon} color={iconColor} size={62} />}
      <Heading as="h3" size="lg" my="30px">
        {title}
      </Heading>
      <Text variant="card">{desc}</Text>
    </Box>
  )
}
